export type PagePdfExportVersion = 'V1' | 'V2' | 'V3' | '%future added value';

export type PagePdfExportMutationErrorExtension = {
	readonly __typename?: string;
	readonly errorType: string | null;
	readonly statusCode: number | null;
};

export type PagePdfExportMutationError = {
	readonly __typename?: 'MutationError';
	readonly message: string | null;
	readonly extensions: PagePdfExportMutationErrorExtension | null;
};

export type PagePdfExportCreateResult = {
	readonly success?: boolean | null;
	readonly exportVersion?: PagePdfExportVersion | null;
	readonly exportTaskId?: string | null;
	readonly errors?: ReadonlyArray<PagePdfExportMutationError> | null;
} | null;

export type PagePdfExportCreateDecision =
	| {
			readonly type: 'legacy';
	  }
	| {
			readonly type: 'modal';
			readonly exportTaskId?: string | null;
	  }
	| {
			readonly type: 'error';
			readonly reason: 'create-failed' | 'unsupported-export-version';
			/** Coded backend error from the create mutation (safe for analytics — not free text). */
			readonly errorCode?: string | null;
			/** HTTP-level status code from the create mutation error, when present. */
			readonly statusCode?: number | null;
	  };

type ResolvePagePdfExportCreateResultOptions = {
	readonly createResult?: PagePdfExportCreateResult;
	readonly isExperimentEnabled: boolean;
};

export const resolvePagePdfExportCreateResult = ({
	createResult,
	isExperimentEnabled,
}: ResolvePagePdfExportCreateResultOptions): PagePdfExportCreateDecision => {
	if (!createResult || createResult.success === false || Boolean(createResult.errors?.length)) {
		const errorCode =
			createResult?.errors
				?.map((error) => error?.extensions?.errorType)
				.find((value): value is string => Boolean(value)) ?? null;
		const statusCode =
			createResult?.errors
				?.map((error) => error?.extensions?.statusCode)
				.find((value): value is number => value != null) ?? null;
		return {
			type: 'error',
			reason: 'create-failed',
			errorCode,
			statusCode,
		};
	}

	if (!isExperimentEnabled) {
		return {
			type: 'legacy',
		};
	}

	switch (createResult.exportVersion) {
		case 'V1':
		case 'V2':
			return {
				type: 'legacy',
			};
		case 'V3':
			return {
				type: 'modal',
				exportTaskId: createResult.exportTaskId,
			};
		default:
			return {
				type: 'error',
				reason: 'unsupported-export-version',
			};
	}
};
